import { formatVariation } from "@/utils/percentage";

// Etiqueta del período-sobre-período según granularidad: "MoM" en mensual,
// "QoQ" en trimestral. En YTD/Anual no aplica (la lectura útil ahí es YoY) →
// null oculta esa línea del tooltip.
export function periodOverPeriodLabel(filterPeriod) {
    if (filterPeriod === "month") return "MoM";
    if (filterPeriod === "quarter") return "QoQ";
    return null;
}

// Variación de un valor contra un peer (mes/trimestre previo para MoM/QoQ, o el
// mismo período del año anterior para YoY). `prev` null o 0 → "—" neutro (no se
// inventa peer y la división por 0 explota). Devuelve {text, color}.
function variationFor(value, prev) {
    if (prev == null || prev === 0) {
        return { text: "—", color: "var(--report-text-muted)" };
    }
    const ratio = value / prev - 1;
    let color = "var(--report-text-muted)";
    if (ratio > 0) color = "var(--report-positive)";
    else if (ratio < 0) color = "var(--report-negative)";
    return {
        text: formatVariation(ratio, { withArrow: true, withSign: true }),
        color,
    };
}

// Tooltip per-cell de la tabla de evolución: MoM/QoQ (vs columna previa de la
// misma fila) + YoY (vs `prevYearValues[idx]`). HTML inline porque floating-vue
// resuelve `var(--…)` dentro del portal (hereda :root, fuera del subárbol
// scoped). `row` debe traer `values[]`; el YoY es opt-in vía `prevYearValues[]`.
// La línea YoY se omite cuando la fila NO trae `prevYearValues` — algunos
// reportes (p.ej. Estado de resultados) no exponen peer del año anterior, y
// mostrar "YoY: —" siempre sería ruido. Un `prevYearValues[idx]` puntualmente
// null (peer ausente en esa columna) sí muestra "—": es la distinción entre
// "el reporte no tiene YoY" y "esta columna no tiene comparable".
export function cellVariationTooltip(row, idx, filterPeriod) {
    const value = row.values[idx] ?? 0;
    const lines = [];

    const popLabel = periodOverPeriodLabel(filterPeriod);
    if (popLabel) {
        // Peer del período anterior desde data REAL (`prevPeriodValues[idx]`)
        // cuando la fila lo expone — así la primera columna visible también
        // tiene MoM/QoQ contra el período real previo (que puede caer fuera del
        // rango filtrado). Fallback a la columna visible previa para filas que
        // aún no traen el peer real (mismo número salvo en la primera columna).
        const prevPeriod = row.prevPeriodValues
            ? (row.prevPeriodValues[idx] ?? null)
            : (idx > 0 ? (row.values[idx - 1] ?? null) : null);
        const pop = variationFor(value, prevPeriod);
        lines.push(`${popLabel}: <span style="color:${pop.color};font-weight:600;">${pop.text}</span>`);
    }

    if (row.prevYearValues) {
        const yoy = variationFor(value, row.prevYearValues[idx]);
        lines.push(`YoY: <span style="color:${yoy.color};font-weight:600;">${yoy.text}</span>`);
    }

    return { content: lines.join("<br>"), html: true };
}
